import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

const StudentProgressTrophiesWidget = observer((props = {}) => {
  const { onlyRenderInnerWidgetContent, t } = props;

  const { studentProgressManager } = useContext(MobXProviderContext);
  const { trophyCounts } = studentProgressManager;

  // TODO unused
  // Set default loading value when not provided
  // const loading = props.loading !== undefined ? props.loading : (
  //   appManager.initializingApp || !userManager.loaded || !classroomManager.loaded;
  // );

  const Trophy = SatCoreComponent('Trophy');

  const trophiesLabel = t('TrophiesLabel', 'Missing trophies label translation');

  const innerWidgetContent = (
    <div className='trophy-content'>
      <Trophy count={trophyCounts.gold} type='gold' />
      <div className='trophy-spacer' />
      <Trophy count={trophyCounts.silver} type='silver' />
    </div>
  );

  return !onlyRenderInnerWidgetContent ? (
    <div className='StudentProgressTrophiesWidget StudentProgressWidget widget trophies-widget' tabIndex='0'>
      <h2 aria-label={`${trophiesLabel}:`} className='w-title'>{trophiesLabel}</h2>
      {innerWidgetContent}
    </div>
  ) : innerWidgetContent;
});

export default StudentProgressTrophiesWidget;

SatCoreRegister('StudentProgressTrophiesWidget', StudentProgressTrophiesWidget);
